import React from 'react';
import './styles.css';





export const CarmenAyudanteIzquierda = () => {


  return (
    <>


        <div className='CarmenAyudanteIzquierda-Container'>

              <div className='CarmenAyudanteIzquierda-maestra' />

              <div className='CarmenAyudanteIzquierda-nombre-texto-container'>
                  
                    <div className='CarmenAyudanteIzquierda-nombre' />

                    <div className='CarmenAyudanteIzquierda-texto'>

                        Apoyo educativo.
                        
                    </div>

              </div>

        </div>


    </>
  )
}
